<app-search-drawer #searchDrawer></app-search-drawer>

<div
  class="tw-grid tw-h-[3.125rem] tw-grid-cols-12 tw-items-center tw-gap-2 tw-bg-secondary tw-px-3"
>
  <!-- begin::Title -->
  <span
    class="tw-text-sm tw-text-secondary-content sm:tw-text-xl"
    [ngClass]="{
      'tw-col-span-3 tw-hidden xs:tw-block sm:tw-col-span-3': itinerary(),
      'tw-col-span-7 md:tw-col-span-6': !itinerary(),
    }"
  >
    {{ title() }}
  </span>
  <!-- end::Title -->

  <!-- begin::Info -->
  @if (itinerary()) {
    <div
      class="tw-col-span-7 tw-flex tw-flex-col tw-justify-center tw-text-secondary-content xs:tw-col-span-6 xs:tw-items-center"
    >
      <span>
        {{ itinerary()?.from?.city }}
        <i class="fa-solid fa-arrow-right-long"></i>
        {{ itinerary()?.to?.city }}
      </span>
      <div class="tw-text-sm sm:tw-text-[length:inherit]">
        <span>
          {{ itinerary()?.date | date: "EEEE, dd/MM/yyyy" }}
        </span>
        <span class="tw-hidden sm:tw-inline">
          (AL: {{ itinerary()!.date | lunarDate: "DD/MM/YYYY" }})
        </span>
        <span class="tw-inline sm:tw-hidden">
          ({{ itinerary()!.date | lunarDate: "DD/MM" }})
        </span>
      </div>
    </div>
  }
  <!-- end::Info -->

  <!-- begin::Action -->
  <div
    class="tw-col-span-5 tw-flex tw-justify-end tw-gap-2 sm:tw-gap-3"
    [ngClass]="{
      'xs:tw-col-span-3': itinerary(),
      'tw-col-start-8 md:tw-col-span-6 md:tw-col-start-7': !itinerary(),
    }"
  >
    @if (showCheapPricesButton()) {
      <button
        class="tw-min-h-10 tw-min-w-10 tw-rounded-full tw-bg-secondary-700 tw-text-sm tw-text-secondary-content tw-transition-colors active:tw-bg-secondary-400 active:tw-text-secondary-content md:tw-text-lg"
        (click)="onShowCheapPrices()"
      >
        <i class="fa-regular fa-calendar-days"></i>
      </button>
    }

    @if (showSmartComboButton()) {
      <button
        class="tw-min-h-10 tw-min-w-10 tw-animate-border-spin tw-rounded-full tw-border-2 tw-border-transparent tw-px-3 tw-text-sm tw-font-semibold active:tw-scale-95"
        [ngClass]="{
          'tw-text-primary [background:linear-gradient(45deg,theme(colors.primary.content),theme(colors.primary.content))_padding-box,conic-gradient(from_var(--border-angle),theme(colors.slate.600/.48)_80%,_theme(colors.primary.500)_86%,_theme(colors.primary.300)_90%,_theme(colors.primary.500)_94%,_theme(colors.slate.600/.48))_border-box]':
            !showSmartCombo(),
          'tw-bg-primary tw-text-primary-content': showSmartCombo(),
          'tw-pointer-events-none tw-opacity-80': isLoading(),
        }"
        (click)="onToggleSmartCombo()"
      >
        <div class="tw-flex tw-items-center tw-gap-1">
          <i class="fa-solid fa-percent tw-text-sm"></i>
          <span class="tw-hidden tw-text-xs lg:tw-inline lg:tw-text-sm">
            Combo
            <!-- <span class="tw-hidden lg:tw-inline">khứ hồi</span> -->
          </span>
        </div>
      </button>
    }

    @if (showCompactButton()) {
      <button
        class="tw-hidden tw-min-h-10 tw-min-w-10 tw-rounded-full tw-text-base tw-transition-shadow tw-duration-150 hover:tw-shadow-[0_0_8px_1px_rgba(255,255,255,0.4)] active:tw-scale-95 ms:tw-inline"
        [ngClass]="{
          'tw-bg-primary-content tw-text-primary': !showCompact(),
          'tw-bg-primary tw-text-primary-content': showCompact(),
        }"
        (click)="showCompactChange.emit()"
      >
        <i class="fa-solid fa-compress"></i>
      </button>
    }

    @if (showDownloadPriceButton()) {
      <button
        class="tw-min-h-10 tw-min-w-10 tw-rounded-full tw-bg-secondary-700 tw-text-sm tw-text-secondary-content tw-transition-colors active:tw-bg-secondary-400 active:tw-text-secondary-content md:tw-text-lg"
        (click)="onShowDownloadPrice()"
      >
        <i class="fa-solid fa-download"></i>
      </button>
    }

    <button
      class="tw-min-h-10 tw-min-w-10 tw-rounded-full tw-bg-[#0dcaf0] tw-text-sm tw-text-primary-content active:tw-scale-95"
      [ngClass]="{
        'tw-inline-block 2xl:tw-hidden': appSettings.isPage() && step() === 1,
      }"
      (click)="searchDrawer.open()"
    >
      <i class="fa-solid fa-search"></i>
    </button>
  </div>
  <!-- end::Action -->
</div>
